export default "__VITE_ASSET__719d0e98__$_?nuxt_component=async__"